import { lazy, Suspense } from 'react'
import { Loader2 } from 'lucide-react'
import type { OriginMapPoint } from '../../lib/originCityCoords'
import { useT } from '../../i18n/t'

const ParticipantsOriginMapInner = lazy(() =>
  import('./ParticipantsOriginMapInner').then((m) => ({
    default: m.ParticipantsOriginMapInner,
  })),
)

type ParticipantsOriginMapProps = {
  points: OriginMapPoint[]
  className?: string
}

export function ParticipantsOriginMap({ points, className = '' }: ParticipantsOriginMapProps) {
  const { t } = useT()

  if (!points.length) {
    return (
      <p
        className={`pds-surface pds-surface--dashed bg-ink/[0.02] px-4 py-8 text-center text-sm font-semibold text-ink/60 ${className}`}
      >
        {t('landing.socialProof.map.empty')}
      </p>
    )
  }

  return (
    <div className={className}>
      <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-ink/55">
        {t('landing.socialProof.map.eyebrow')}
      </p>
      <div className="overflow-hidden pds-surface ">
        <Suspense
          fallback={
            <div
              className="flex h-[280px] items-center justify-center bg-ink/[0.03] md:h-[360px]"
              aria-busy="true"
            >
              <Loader2 className="h-6 w-6 animate-spin text-ink/45" aria-hidden />
              <span className="sr-only">{t('landing.socialProof.map.loading')}</span>
            </div>
          }
        >
          <ParticipantsOriginMapInner points={points} />
        </Suspense>
      </div>
      <p className="mt-2 text-[12px] font-medium text-ink/50">{t('landing.socialProof.map.hint')}</p>
    </div>
  )
}
